/**
 * Run `fn` when the browser is idle (KPR-1188: the icon picker prefetches the
 * next page's artwork this way, so it never competes with what the person is
 * doing). Returns the cancel function; cleaning an effect up calls it.
 * requestIdleCallback where there is one (Safari has none), a short timeout
 * otherwise. `timeout` caps the wait on a busy page.
 */
export function whenIdle(fn, timeout = 2000) {
	if (typeof window !== 'undefined' && typeof window.requestIdleCallback === 'function') {
		const id = window.requestIdleCallback(() => fn(), { timeout });
		return () => {
			if (typeof window.cancelIdleCallback === 'function') window.cancelIdleCallback(id);
		};
	}
	const id = setTimeout(fn, 250);
	return () => clearTimeout(id);
}

/** False when the person asked the browser to save data (or is on a 2G link): nothing is fetched on a guess. */
export function mayPrefetch() {
	if (typeof navigator === 'undefined') return true;
	const connection = navigator.connection;
	if (!connection) return true;
	return !connection.saveData && !/(^|-)2g$/.test(`${connection.effectiveType || ''}`);
}
